import { render, staticRenderFns } from "./FilterContactModule.vue?vue&type=template&id=3a63b6dd&scoped=true&"
import script from "./FilterContactModule.vue?vue&type=script&lang=js&"
export * from "./FilterContactModule.vue?vue&type=script&lang=js&"
import style0 from "./FilterContactModule.vue?vue&type=style&index=0&id=3a63b6dd&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63b6dd",
  null
  
)

export default component.exports